import { useCommunity } from '~/contexts/CommunityContext'
import { useAuth } from '~/auth/Auth'
import { useNavigate } from 'react-router'
import FreeSiteSettings from '~/pages/company/FreeSiteSettings'
import { RestrictedSiteSettings } from '~/pages/company/RestrictedSiteSettings'

export const CompanySettings = () => {
  const { isVeevan, loading: authLoading } = useAuth()
  const navigate = useNavigate()

  const { isRestricted, isFreeSite, loading } = useCommunity()

  if ((!loading && !isFreeSite && !isRestricted) || (!authLoading && !isVeevan)) {
    void navigate('../home}')
  }

  if (isFreeSite) {
    return <FreeSiteSettings creatingFreeSite={false} />
  }

  return <RestrictedSiteSettings />
}
